export default __webpack_public_path__ + "static/media/logo_white.9a4d216b.svg";